(()=>{if(window.__MXP_MACBOOK_COLOR_BUBBLES_V2__)return;window.__MXP_MACBOOK_COLOR_BUBBLES_V2__=1;
'use strict';
const clean=v=>String(v||'').replace(/\s+/g,' ').trim();
const norm=v=>clean(v).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase();
const SWATCH={
  'ARGENT':'#e3e4e5','SILVER':'#e3e4e5',
  'GRIS SIDERAL':'#5f6063','SPACE GRAY':'#5f6063','SPACE GREY':'#5f6063',
  'NOIR SIDERAL':'#2f3033','SPACE BLACK':'#2f3033',
  'OR':'#d9c3a5','GOLD':'#d9c3a5','OR ROSE':'#d8b3a8','ROSE GOLD':'#d8b3a8',
  'BLEU CIEL':'#b8c8d8','SKY BLUE':'#b8c8d8','MINUIT':'#29313b','MIDNIGHT':'#29313b',
  'LUMIERE STELLAIRE':'#e7d8c5','STARLIGHT':'#e7d8c5',
  'ROSE POUDRE':'#e8c2c8','JAUNE AGRUME':'#e3d66d','INDIGO':'#5964a6'
};
const BLACK=new Set(['NOIR SIDERAL','SPACE BLACK']);
const GRAY=new Set(['GRIS SIDERAL','SPACE GRAY','SPACE GREY']);
const SILVER=new Set(['ARGENT','SILVER']);
const explicitVariant=new URLSearchParams(location.search).has('variant');
let defaultApplied=explicitVariant;
function preferredDark(buttons){
  return buttons.find(b=>BLACK.has(norm(b.dataset.value)))||buttons.find(b=>GRAY.has(norm(b.dataset.value)))||null;
}
function reorderColors(wrap,buttons){
  const preferred=preferredDark(buttons);
  const silvers=buttons.filter(b=>SILVER.has(norm(b.dataset.value)));
  if(preferred){
    const others=buttons.filter(b=>b!==preferred&&!SILVER.has(norm(b.dataset.value)));
    const desired=[preferred,...silvers,...others];
    if(desired.some((button,index)=>button!==buttons[index]))desired.forEach(button=>wrap.appendChild(button));
  }else if(silvers.length){
    const others=buttons.filter(b=>!SILVER.has(norm(b.dataset.value)));
    const desired=[...silvers,...others];
    if(desired.some((button,index)=>button!==buttons[index]))desired.forEach(button=>wrap.appendChild(button));
  }
}
function applyDarkDefault(buttons){
  if(defaultApplied)return;
  const target=preferredDark(buttons);
  if(!target){defaultApplied=true;return;}
  if(target.disabled)return;
  defaultApplied=true;
  if(target.getAttribute('aria-pressed')==='true')return;
  requestAnimationFrame(()=>{
    if(target.isConnected&&!target.disabled&&target.getAttribute('aria-pressed')!=='true')target.click();
  });
}
function harmonizeGroup(wrap){
  const buttons=Array.from(wrap.querySelectorAll('.mps-mac-color-choice[data-value]'));
  if(!buttons.length)return;
  buttons.forEach(button=>{
    const key=norm(button.dataset.value);
    const dot=button.querySelector('.mps-mac-color-dot');
    if(dot&&SWATCH[key])dot.style.setProperty('--mps-swatch',SWATCH[key]);
  });
  reorderColors(wrap,buttons);
  applyDarkDefault(buttons);
}
function harmonize(){document.querySelectorAll('.mps-mac-color-group .option__values').forEach(harmonizeGroup)}
function boot(){harmonize();requestAnimationFrame(harmonize);setTimeout(harmonize,100);setTimeout(harmonize,300)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',boot);
new MutationObserver(harmonize).observe(document.documentElement,{childList:true,subtree:true});
})();
